const { parseBackendLocalDateTimeMs } = require('./parseBackendLocalDateTimeMs');

function toTimestamp(value) {
  const ms = parseBackendLocalDateTimeMs(value);
  return Number.isFinite(ms) ? ms : 0;
}

function toNumber(value) {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function filterAndSortMyReviews(reviews, searchQuery, sortBy) {
  let filtered = Array.isArray(reviews) ? [...reviews] : [];
  const q = String(searchQuery || '').trim().toLowerCase();

  if (q) {
    filtered = filtered.filter(item => {
      const fields = [
        item.name,
        item.houseName,
        item.address,
        item.area,
        item.content,
        item.district,
        item.region
      ];
      return fields.some(field => field && String(field).toLowerCase().includes(q));
    });
  }

  switch (sortBy) {
    case 'latest':
      filtered.sort((a, b) => {
        const db = toTimestamp(b.dateTime) - toTimestamp(a.dateTime);
        if (db !== 0) return db;
        return (Number(b.id) || 0) - (Number(a.id) || 0);
      });
      break;
    case 'earliest':
      filtered.sort((a, b) => {
        const db = toTimestamp(a.dateTime) - toTimestamp(b.dateTime);
        if (db !== 0) return db;
        return (Number(a.id) || 0) - (Number(b.id) || 0);
      });
      break;
    case 'rating-high':
      filtered.sort((a, b) => toNumber(b.average) - toNumber(a.average));
      break;
    case 'rating-low':
      filtered.sort((a, b) => toNumber(a.average) - toNumber(b.average));
      break;
    case 'price-high':
      filtered.sort((a, b) => toNumber(b.monthlyRent) - toNumber(a.monthlyRent));
      break;
    case 'price-low':
      filtered.sort((a, b) => toNumber(a.monthlyRent) - toNumber(b.monthlyRent));
      break;
    default:
      break;
  }

  return filtered;
}

module.exports = {
  filterAndSortMyReviews
};
